import { render, staticRenderFns } from "./ClinicOnlineMedical.vue?vue&type=template&id=753de60f&scoped=true&"
import script from "./ClinicOnlineMedical.vue?vue&type=script&lang=js&"
export * from "./ClinicOnlineMedical.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOnlineMedical.vue?vue&type=style&index=0&id=753de60f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753de60f",
  null
  
)

export default component.exports